import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoUnsubscribeComponent } from 'src/app/shared/utils/auto-unsubscribe.component';

@Component({
  selector: 'app-stepper-lto',
  templateUrl: './stepper-lto.component.html',
  styleUrls: ['./stepper-lto.component.scss']
})
export class StepperLtoComponent extends AutoUnsubscribeComponent {
  public hidePageConfirmationPlatform = false;
  public hiddeAlert = false;
  public whereFindOutId?: string;
  public showConfirmationStep = false;
  public successBack = false;
  public successType: 'referrer' | 'iaAgent' = 'referrer';

  campaignsWithExternalNumberAllowed: string[] = ['cd07107a-b988-43e3-b570-d2b7810b93e0'];

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    super();
    const activatedRouteSubscription$ = this.activatedRoute.url.subscribe(segments => {
    const segmentPaths = segments.map(segment => segment.path);
      if (segmentPaths.includes('from-legacy')) {
        this.navigateToWelcomeForm();
      }
    });
    this.subscriptions.push(activatedRouteSubscription$);

    this.activatedRoute.queryParams.subscribe((params) => {
      this.whereFindOutId = params['whereFindOutId'];
    });
  }

  get referrerPage(): boolean {
    return !!this.whereFindOutId && this.campaignsWithExternalNumberAllowed.includes(this.whereFindOutId);
  }

  goToRefer(): void {
    this.showConfirmationStep = false;
    this.successBack = false;
  }

  ngOnInit(): void {
    const pathname = window.location.pathname;
    if (pathname === '/mx/solicitud/form/bienvenida') {
      this.hidePageConfirmationPlatform = true;
    }
  }

  closeAlert() {
    this.hiddeAlert = true;
  }

  navigateToWelcomeForm(): void {
    this.router.navigate(['/mx/solicitud/form/bienvenida'], {
      queryParams: {
        creditType: '1',
        whereFindOutId: '434de4c9-28f1-46a0-8a1e-c9c352421498'
      }
    }).then(() => {
      window.location.reload();
    });
  }

  showConfirmationStepEmit($event: string): void {
    this.showConfirmationStep = true;
    this.successBack = true;
    this.successType = $event as 'referrer' | 'iaAgent';
  }
}
